import apiVirtus from './apiVirtus';

// Dados da empresa por CNPJ (backend-virtus): formas de pagamento em
// recorrência (`recurrent_payment_methods`).
//
// Não usar este serviço para `recurrence_enabled` — o schema Mongoose de
// Empresas em backend-virtus não declara esse campo, então GET /empresa/{cnpj}
// nunca o expõe mesmo que exista no documento. A habilitação do toggle de
// recorrência no Checkout usa a lista `companies` do login/sessão (mesma fonte
// do app-cliente — CA6), ver functions/recurrence.js.
//
// Guard de autenticação deste endpoint não confirmado; mandamos o Bearer por
// consistência com os demais serviços por-CNPJ (ver discountRules.js). Se o
// endpoint exigir auth e o token estiver ausente/expirado, a falha cai no
// catch abaixo e retorna {} — mesmo resultado seguro de "não habilitado".
//
// Qualquer falha (rede, CNPJ inválido, empresa sem os campos) retorna {} —
// quem consome este serviço trata ausência de dado como "não habilitado".
const authHeaders = () => {
  const token = JSON.parse(sessionStorage.getItem('@portal-cliente/token'));
  return token ? { headers: { Authorization: 'Bearer ' + token } } : {};
};

export async function getCompanyInfo(cnpj) {
  if (!cnpj) return {};
  try {
    const { data } = await apiVirtus.get(`/empresa/${cnpj}`, authHeaders());
    return data || {};
  } catch {
    return {};
  }
}
